<template>
  <div>
    <!-- <h1 class="filter-header">Template</h1> -->
    <div class="communication-container">
      <div class="side-menu">
        <div class="items-wrapper">
          <el-form v-model="form">
            <!-- <h3>SEO</h3> -->
            <el-row>
              <el-form-item label="Title">
                <el-input v-model="form.name"></el-input>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="Slug">
                <el-input disabled v-model="form.slug"></el-input>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="Description">
                <el-input type="textarea" v-model="form.description"></el-input>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item prop="isActive" label="Active">
                <el-select v-model="form.isActive" placeholder="Active">
                  <el-option :value="true" label="Yes"></el-option>
                  <el-option :value="false" label="No"></el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item prop="availableDates" label="Dates Available">
                <el-date-picker
                    :value="[form.availableDates.from, form.availableDates.to]"
                    v-on:input="onDateRangeChange"
                    type="daterange"
                    range-separator="-"
                    value-format="timestamp"
                    start-placeholder="Start date"
                    end-placeholder="End date"
                  ></el-date-picker>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item prop="backgroundColor" label="Background Color">
                <br>
                <el-color-picker v-model="form.meta.backgroundColor" size="large" color-format='rgb'></el-color-picker>
              </el-form-item>
            </el-row>
          </el-form>
          <div class="action-buttons mt-1">
          </div>
          <div class="action-buttons mt-1">
            <el-button @click="$router.push({name: 'landing-pages.list'})">Cancel</el-button>
            <el-button type="primary" @click="submit">Save</el-button>
          </div>
        </div>
      </div>
      <div class="editor" v-if="editor">
        <div class="controls">
          <h3>Preview <a class="" :href="bookingUrl" target="_blank">{{form.isActive ? '(Link)':''}}</a></h3>
          <div class="d-flex flex-align-items-center">
            <input
              :style="{marginRight: '10px'}"
              type="color"
              @input="editor.chain().focus().setColor($event.target.value).run()"
              :value="editor.getAttributes('textStyle').color"
            />
            <el-button type="text" @click="showDialog = true">
              <fa-icon :icon="['far', 'image']" size="lg" />
            </el-button>
            <el-button
              type="text"
              @click="editor.chain().focus().insertTable({ rows: 3, cols: 3, withHeaderRow: true }).run()"
            >
              <fa-icon :icon="['fal', 'table']" size="lg" />
            </el-button>

            <el-button
              type="text"
              @click="newButtonDialogVisible = true"
            >
              <!-- <fa-icon :icon="['fal', 'table']" size="lg" /> -->
              Button
            </el-button>

            <el-button
              type="text"
              @click="editor.chain().focus().setHorizontalRule().run()"
            >
              <fa-icon :icon="['fal', 'horizontal-rule']" size="lg" />
            </el-button>
            <el-button
              type="text"
              @click="setFrame"
            >
              Iframe
            </el-button>
          </div>
        </div>
        <div class="editor-section" :style="{backgroundColor: form.meta.backgroundColor}">
          <bubble-menu :editor="editor" class="bubble-menu">
            <div v-show="!editor.isActive('comms-image')">
            <span
              @click="editor.chain().focus().toggleBold().run()"
              :class="{ 'is-active': editor.isActive('bold'), 'bubble-menu-command': true }"
            >
              <fa-icon :icon="['far', 'bold']" />
            </span>
            <span
              @click="editor.chain().focus().toggleItalic().run()"
              :class="{ 'is-active': editor.isActive('italic'), 'bubble-menu-command': true, 'mb-10': true }"
            >
              <fa-icon :icon="['far', 'italic']" />
            </span>
            <span
              @click="setLink"
              :class="{ 'is-active': editor.isActive('link'), 'bubble-menu-command': true }"
            >
              <fa-icon :icon="['far', 'link']" />
            </span>
            <span
              @click="editor.chain().focus().toggleHeading({ level: 1 }).run()"
              :class="{ 'is-active': editor.isActive('heading', { level: 1 }), 'bubble-menu-command': true }"
            >
              <fa-icon :icon="['far', 'h1']" />
            </span>
            <span
              @click="editor.chain().focus().toggleHeading({ level: 2 }).run()"
              :class="{ 'is-active': editor.isActive('heading', { level: 2 }), 'bubble-menu-command': true  }"
            >
              <fa-icon :icon="['far', 'h2']" />
            </span>
            <span
              @click="editor.chain().focus().toggleHeading({ level: 3 }).run()"
              :class="{ 'is-active': editor.isActive('heading', { level: 3 }), 'bubble-menu-command': true  }"
            >
              <fa-icon :icon="['far', 'h3']" />
            </span>
            <span
              @click="editor.chain().focus().toggleStrike().run()"
              :class="{ 'is-active': editor.isActive('strike'), 'bubble-menu-command': true  }"
            ><fa-icon :icon="['far', 'strikethrough']" /></span>
            <span
              @click="editor.chain().focus().toggleHighlight().run()"
              :class="{ 'is-active': editor.isActive('highlight') , 'bubble-menu-command': true }"
            >
              <fa-icon :icon="['far', 'highlighter']" />
            </span>
            <span
              @click="editor.chain().focus().setTextAlign('left').run()"
              :class="{ 'is-active': editor.isActive({ textAlign: 'left' }) , 'bubble-menu-command': true}"
            >
              <fa-icon :icon="['far', 'align-left']" />
            </span>
            <span
              @click="editor.chain().focus().setTextAlign('center').run()"
              :class="{ 'is-active': editor.isActive({ textAlign: 'center' }) , 'bubble-menu-command': true}"
            >
              <fa-icon :icon="['far', 'align-center']" />
            </span>
            <span
              @click="editor.chain().focus().setTextAlign('right').run()"
              :class="{ 'is-active': editor.isActive({ textAlign: 'right' }) , 'bubble-menu-command': true}"
            >
              <fa-icon :icon="['far', 'align-right']" />
            </span>
            </div>
            <span
              class="bubble-image"
              tippy-options="{ animation: false }"
              :editor="editor"
              v-if="editor"
              v-show="editor.isActive('comms-image')"
            >
              <button
                @click="setImageAttributes({ size: 'small', style: currentAttributes.style, width: '200px' })"
                :class="{
                'is-active': editor.isActive('comms-image', {
                  size: 'small',
                })
              }"
              >Small</button>
              <button
                @click="setImageAttributes({ size: 'medium', style: 'float: none', width: '500px' })"
                :class="{
                'is-active': editor.isActive('comms-image', {
                  size: 'medium'
                })
              }"
              >Medium</button>
              <button
                @click="setImageAttributes({ size: 'large', style: 'float: none', width: '100%' })"
                :class="{
                'is-active': editor.isActive('comms-image', {
                  size: 'large'
                })
              }"
              >Large</button>
              <span v-show="currentAttributes.width==='200px'">
                <span style="color: #aaa">|</span>
                <button
                  @click="setImageAttributes({ float: 'left', style: 'float: left', width: currentAttributes.width })"
                  :class="{
                  'is-active': editor.isActive('comms-image', {
                    float: 'left'
                  })
                }"
                >Left</button>
                <button
                  @click="setImageAttributes({ float: 'none', style: 'float: none', width: currentAttributes.width })"
                  :class="{
                  'is-active': editor.isActive('comms-image', {
                    float: 'none'
                  })
                }"
                >Center</button>
                <button
                  @click="setImageAttributes({ float: 'right', style: 'float: right', width: currentAttributes.width })"
                  :class="{
                  'is-active': editor.isActive('comms-image', {
                    float: 'right'
                  })
                }"
                >Right</button>
              </span>
            </span>
          </bubble-menu>
          <editor-content :editor="editor" v-model="form.content" />
          <p class="footer">Copyright 2025 Assemble Sports | All Rights Reserved</p>
        </div>
      </div>
    </div>
    <comms-upload-dialog v-model="showDialog" @addImage="addImage" />
    <el-dialog :visible.sync="newButtonDialogVisible" destroy-on-close @close="clearNewButtonDialog" title="New Button">
      <!-- Add new button with url & text -->
      <el-form :model="newButtonForm">
        <el-form-item label="Button Text">
          <el-input v-model="newButtonForm.text" placeholder="Button Text" />
        </el-form-item>
        <el-form-item label="Button URL">
          <el-input v-model="newButtonForm.url" placeholder="Button URL" />
        </el-form-item>
        <div class="d-flex flex-justify-end">
          <el-button type="primary" @click="addNewButton">Add</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import _ from 'lodash';
import { fileUploadAcceptString } from '@/utils/constants';
import { Editor, EditorContent, BubbleMenu } from '@tiptap/vue-2';
import StarterKit from '@tiptap/starter-kit';
import Link from '@tiptap/extension-link';
import Table from '@tiptap/extension-table';
import TableRow from '@tiptap/extension-table-row';
import TableCell from '@tiptap/extension-table-cell';
import TableHeader from '@tiptap/extension-table-header';
import TextAlign from '@tiptap/extension-text-align';
import Highlight from '@tiptap/extension-highlight';
import TextStyle from '@tiptap/extension-text-style';
import { Color } from '@tiptap/extension-color';
import CommsUploadDialog from './components/CommsUploadDialog.vue';
import CommsImage from './extensions/comms-image.js';
import Iframe from './extensions/iframe.js';
import VueComponent from './extensions/button';

const CustomTableCell = TableCell.extend({
  addAttributes() {
    return {
      // extend the existing attributes …
      ...this.parent?.()

      // and add a new one …
      // backgroundColor: {
      // default: 'white',
      // parseHTML: (element) => element.getAttribute('data-background-color'),
      // renderHTML: (attributes) => ({
      //   'data-background-color': attributes.backgroundColor,
      //   style: `background-color: ${attributes.backgroundColor}`
      // })
      // }
    };
  }
});

export default {
  components: {
    EditorContent,
    BubbleMenu,
    CommsUploadDialog
  },
  data() {
    return {
      fileUploadAcceptString,
      popperVisible: false,
      showDialog: false,
      newButtonDialogVisible: false,
      newButtonForm: {
        text: '',
        url: ''
      },
      form: {
        name: undefined,
        description: undefined,
        slug: undefined,
        content: undefined,
        availableDates: {
          from: undefined,
          to: undefined
        },
        isActive: true,
        meta: {
          backgroundColor: undefined
        }
      },
      // fileList: [{ name: 'food.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100' }, { name: 'food2.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100' }],
      activeStatuses: [
        { label: 'Active', value: true },
        { label: 'Inactive', value: false }
      ],
      currentAttributes: {
        width: '200px',
        style: 'float: none'
      },
      editor: null
    };
  },
  mounted() {
    this.editor = new Editor({
      content: `
              <h2>Welcome to Assemble Sports</h2>
              <p> This is a message from the team at Assemble Sports. We want to give you a warm welcome and good wishes for your next season. </p>
              <p> Stay safe, stay healthy, play on! </p>
              <p> All. In. </p>  
              `,
      extensions: [
        StarterKit,
        Link,
        Color,
        TextStyle,
        Iframe,
        VueComponent,
        Table.configure({
          resizable: true
        }),
        TableRow,
        // TableCell,
        TableHeader,
        CustomTableCell,
        TextAlign.configure({
          types: ['heading', 'paragraph']
        }),
        Highlight,
        CommsImage.configure({
          HTMLAttributes: {
            class: 'comms-image'
          }
        }),
      ]
    });
    const { id } = this.$route.params;
    if (id) {
      this.$store.commit('loading', true);
      this.$http
        .get(`/assemble/api/v1/admin/landing-pages/${id}`)
        .then((res) => {
          this.form = _.merge(this.form, res.data.data);
          this.editor.commands.setContent(this.form.content, false);
        })
        .catch(() => {
          this.$message.error('An error occured while loading template');
        })
        .finally(() => {
          this.$store.commit('loading', false);
        });
    }
  },

  computed: {
    isInsert() {
      return this.$route.name === 'forms.add' || this.$route.query.cloneId;
    },
    nationalLogoAccount() {
      // eslint-disable-next-line global-require
      return process.env.VUE_APP_LOGO_ACCOUNT
          && process.env.VUE_APP_LOGO_ACCOUNT !== ''
        ? process.env.VUE_APP_LOGO_ACCOUNT
        : require('@/assets/logos/Assemble_Logo_RGB_Positive.png');
    },
    bookingUrl() {
      const booking = process.env.VUE_APP_BOOKING_URL;
      return `${booking}/landing-pages/${this.form.slug}`;
    }
  },
  methods: {
    clearNewButtonDialog() {
      this.newButtonForm.text = '';
      this.newButtonForm.url = '';
      this.newButtonDialogVisible = false;
    },
    onDateRangeChange(val) {
      const [from, to] = val;
      this.form.availableDates.from = +this.moment(from);
      this.form.availableDates.to = +this.moment(to);
    },
    addNewButton() {
      const { url, text } = this.newButtonForm;
      if (url && text) {
        this.editor.chain().focus().addButton({ url, text }).run();
      }
      this.newButtonForm = {
        text: '',
        url: ''
      };
      this.newButtonDialogVisible = false;
    },
    setFrame() {
      const url = window.prompt('URL');
      if (url) {
        this.editor.chain().focus().setIframe({ src: url }).run();
      }
    },
    setImageAttributes(attributes) {
      if (attributes.size === 'small') this.$set(attributes, 'float', 'none');
      this.currentAttributes.width = attributes.width
        ? attributes.width
        : this.currentAttributes.width;
      this.currentAttributes.style = attributes.style
        ? attributes.style
        : this.currentAttributes.style;
      this.editor
        .chain()
        .focus()
        .setImage(attributes)
        .run();
    },
    addImage(url) {
      if (url) {
        this.editor
          .chain()
          .focus()
          .setImage({ src: url })
          .run();
      }
    },
    setLink() {
      // eslint-disable-next-line no-alert
      const url = window.prompt('URL');
      this.editor
        .chain()
        .focus()
        .setLink({ href: url, target: '_blank' })
        .run();
    },
    submit() {
      const content = this.editor.getJSON();
      this.form.content = content;
      this.$store.commit('loading', true);
      const { id } = this.$route.params;
      if (id) {
        this.$http
          .put(`/assemble/api/v1/admin/landing-pages/${id}`, this.form)
          .then(() => {
            this.$message.success('Update successful');
          })
          .catch(() => {
            this.$message.error('An error occured while updating content');
          })
          .finally(() => {
            this.$store.commit('loading', false);
          });
      } else {
        this.$http
          .post('/assemble/api/v1/admin/landing-pages', this.form)
          .then((res) => {
            this.$message.success('Create successful');
            this.$router.push({
              name: 'landing-pages.update',
              params: { id: res.data.data._id }
            });
          })
          .catch(() => {
            this.$message.error('An error occured while creating content');
          })
          .finally(() => {
            this.$store.commit('loading', false);
          });
      }
      return false;
    }
  },
  watch: {
    // eslint-disable-next-line func-names
    'form.name': function (v) {
      this.form.slug = _.kebabCase(v);
    }
  }
};
</script>
<style lang="scss" scoped>
.popper-container {
  display: flex;
  align-items: center;
  justify-content: space-around;
  img {
    cursor: pointer;
  }
  .required-icon {
    font-size: 2rem;
  }
}

.communication-container {
  min-width: 100%;
  display: grid;
  grid-template-columns: 3fr 7fr;
  gap: 0.5rem;
  .editor {
    margin: 0 auto;
    // background: #FFFFFF;
    background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 0.6),
      rgba(255, 255, 255, 0.6)
    );
    // border: 1px solid rgba(96, 98, 102, 0.5);
    // border: 1px solid #eee;
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
    // filter: drop-shadow(0px 2px 12px rgba(0, 0, 0, 0.1));
    // border-radius: 12px;
    margin-right: 2vmin;
    width: 100%;

    .brand-image {
      margin-top: 2rem;
      max-height: 25%;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        max-height: clamp(5rem, 6vmax, 8rem);
      }
    }
    .editor-section {
      width: 100%;
      min-height: 100vh;

      .bubble-menu {
        padding: 1vmin;
        background: #000;
        box-shadow: 6px 6px 30px rgba(0, 0, 0, 0.05);
        border-radius: 5px;
        .bubble-menu-command {
          cursor: pointer;
          margin-right: 1rem;
          margin-left: 1rem;
          color: white;
          &.is-active {
            color: $highlight;
          }
        }
      }

      .footer {
        text-align: center;
        font-size: 0.875rem;
        line-height: 2.5rem;
        color: #606266;
      }

      ::v-deep.ProseMirror {
        padding: clamp(3rem, 7vmin, 6rem);
        margin: 0;
        box-sizing: border-box;
        box-shadow: none;
        outline: none;
        min-height: 100vh;

        .el-button {
          border-radius: 20px !important;
          background: black !important;
          color: white !important;
          border: none !important;
        }

        p {
          font-size: 1.15rem;
          font-family: "BrownStd-Light";
          line-height: 24px;
        }

        em {
          font-family: "BrownStd-Light";
        }

        strong {
          font-weight: 600;
          color: #152934;
        }

        /* Typography */
        p {margin-bottom: 1rem;}

        h1, h2, h3, h4, h5 {
          // margin: 3rem 0 1.38rem !important;
          margin-bottom: 1.5rem;
          font-family: 'BrownStd-Bold' !important;
          font-weight: 400 !important;
          line-height: 1.3 !important;
        }

        h1 {
          margin-top: 0;
          font-size: clamp(2rem, 3.33vmax, 3.1rem) !important;
        }

        h2 {
          font-size: clamp(1.5rem, 2.71vmax, 2.5rem) !important;
        }

        h3 {
          font-size: clamp(1.25rem, 2.17vmax, 2rem) !important;
        }

        small, .text_small {font-size: 0.8rem;}

        *::selection {
          background: rgba(239, 101, 99, 0.5);
        }
        *::-moz-selection {
          background: rgba(239, 101, 99, 0.5);
        }
      }
    }
  }

  .side-menu {
    padding-right: 2rem;
    // background: #FAFAFA;
    // border: 1px solid #eee;
    // box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
    // border-radius: 3px;

    .items-wrapper {
      position: sticky;
      top: 2.5%;
    }

    .member-count {
      color: #ef6563;
      text-align: right;
    }

    .filter-header {
      font-size: 1.25rem;
      line-height: 2.5rem;
    }

    .action-buttons {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 0.5rem;

      .find-member-btn {
        &:hover {
          border: 1px solid #000;
          background: none;
        }
      }
    }
  }
}

.intro-panel {
  margin-bottom: 1.5rem;
  padding: 20px 20px;
  background-color: #ffffff;
  box-shadow: $boxShadow;
  border: $border;
  border-radius: $borderRadius;
}
</style>

<style lang="scss">

/* Basic editor styles */
.ProseMirror {
  margin: 1rem 0;

  > * + * {
    margin-top: 0.75em;
  }

  ul,
  ol {
    padding: 0 1rem;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    line-height: 1.1;
  }

  code {
    background-color: rgba(#616161, 0.1);
    color: #616161;
  }

  pre {
    background: #0d0d0d;
    color: #fff;
    font-family: "JetBrainsMono", monospace;
    padding: 0.75rem 1rem;
    border-radius: 0.5rem;

    code {
      color: inherit;
      padding: 0;
      background: none;
      font-size: 0.8rem;
    }
  }

  img {
    width: 100%;
    height: auto;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  .comms-image-small {
    max-width: 200px;
  }
  .comms-image-medium {
    max-width: 500px;
  }
  .comms-image-large {
    max-width: 100%;
  }
  .comms-image-float-none {
    float: none;
  }
  .comms-image-float-left {
    float: left;
  }
  .comms-image-float-right {
    float: right;
  }

  blockquote {
    padding-left: 1rem;
    border-left: 2px solid rgba(#0d0d0d, 0.1);
  }

  hr {
    border: none;
    border-top: 2px solid rgba(#0d0d0d, 0.1);
    margin: 2rem 0;
  }
}

.controls {
  color: #606266;
  padding: 0.5rem 1rem;
  border-bottom: 1px dashed rgba(96, 98, 102, 0.5);
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  position: sticky;
  top: 0;
  background: white;
  z-index: 1;
}

/* Table-specific styling */
.ProseMirror {
  table {
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
    margin: 0;
    overflow: hidden;

    td,
    th {
      min-width: 1em;
      border: 2px solid #ced4da;
      padding: 3px 5px;
      vertical-align: top;
      box-sizing: border-box;
      position: relative;
      > * {
        margin-bottom: 0;
      }
    }

    th {
      font-weight: bold;
      text-align: left;
      background-color: #f1f3f5;
    }

    .selectedCell:after {
      z-index: 2;
      position: absolute;
      content: "";
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: rgba(200, 200, 255, 0.4);
      pointer-events: none;
    }

    .column-resize-handle {
      position: absolute;
      right: -2px;
      top: 0;
      bottom: -2px;
      width: 4px;
      background-color: #adf;
      pointer-events: none;
    }

    p {
      margin: 0;
    }
  }
}

.tableWrapper {
  overflow-x: auto;
}

.resize-cursor {
  cursor: ew-resize;
  cursor: col-resize;
}

.iframe-wrapper {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  width: 100%;
  height: auto;

  &.ProseMirror-selectednode {
    outline: 3px solid #68CEF8;
  }

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
